// React
import React from 'react';
import ReactDOM from 'react-dom/client';

// Custom Styles
import './styles/styles.scss';

// Custom Images
import brndImg from './images/Icons/Unreal-old-Logo.svg';
import USAHost from './images/AmericanHosting-chip-optimized.svg';
import supIco from './images/Icons/Support.png';
import prvIco from './images/Icons/Privacy.png';

// Service Agreement
import serviceAgreement from './serviceAgreement.pdf';

// Swiper
import { register } from 'swiper/element/bundle';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const pageData = getPageData();

// register custom elements
register();
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <div>
    <script src="https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js"></script>
    <link rel="stylesheet" media="screen" href="https://fontlibrary.org//face/symbola" type="text/css" />

    {/* Header Section */}
    <header>
      <img className="brand-image" src={brndImg}></img>
      <h1 className="font-light">UnReal Servers</h1>
      <nav className="text-center">
        <ul>
          <a href="#Dedi-Plans" className="font-dark"><li>Plans</li></a>
          <a href="#Reviews" className="font-dark"><li>Reviews</li></a>
          <a href="#Information" className="font-dark"><li>Information</li></a>
        </ul>
      </nav>
    </header>

    {/* Section 1: About UnReal */}
    <section id="About-UnReal">
      <div className="hero-wrapper">
        <img className="hero-image" src={USAHost}></img>
        <div className="text-wrapper font-light">
          <h3 className="about-header">In the heart of America,<br />
            <span style={{ paddingLeft: "1em" }}>find your next hosting provider.</span>
          </h3>
          <p className="about-paragraph">
            High performance, low latency hosting at UnReal prices.<br />
            Select from our flexible lineup, or bring your own<br />
            with colo plans starting as low as $<span id="Colo-Lowest-Price"></span> a month.
          </p>
        </div>
      </div>
    </section>

    {/* Section 2: Dedi Service Plans */}
    <section id="Dedi-Plans">
      <h2 className="font-light text-center">Dedicated Service Plans</h2>
      {/* <!-- Additional required wrapper --> */}
      <div className="swiper-container">
        <div id="Dedi-Swiper"></div>
        <div className="swiper-navigation">
          <a className="dedi-swiper-prev swiper-button-prev"></a>
          <a className="dedi-swiper-next swiper-button-next"></a>
        </div>
      </div>
    </section>

    {/* Section 3: Colo Service Plans */}
    <section id="Colo-Plans">
      <h2 className="font-light text-center">Colocation Service Plans</h2>
      {/* <!-- Additional required wrapper --> */}
      <div className="swiper-container">
        <div id="Colo-Swiper"></div>
        <div className="swiper-navigation">
          <a className="colo-swiper-prev swiper-button-prev"></a>
          <a className="colo-swiper-next swiper-button-next"></a>
        </div>
      </div>
    </section>

    {/* Section 4: Reviews */}
    <section id="Reviews">
      <h2 id="Reviews-Title" className="font-light text-center">Reviews & Testimonials</h2>
      <div id="Reviews-Ratings" className="font-light text-center"></div>
      <br />
      <div id="Reviews-Testimonials"></div>
    </section>
    {/* Footer Section */}
    <footer id="Information">
      <div className="portal-container text-center">
        <div className="portal portal-support">
          <a href="https://my.unrealservers.net/submitticket.php?step=2&deptid=3">
            <img src={supIco}></img>
            <h3 className="portal-title font-light">Support</h3>
          </a>
        </div>
        <div className="portal portal-privacy">
          <a href={serviceAgreement} download>
            <img src={prvIco}></img>
            <h3 className="portal-title font-light">Policy</h3>
          </a>
        </div>
      </div>
      <div className="links-container font-light font-xs">
        <h4>UnReal Servers LLC</h4>
        <p>support@unrealservers.net</p>
        <p>
          UnReal Servers<br />
          1530 Swift St.<br />
          North Kansas City, Mo, 64116
        </p>
      </div>
    </footer>
  </div>
);

async function getPageData() {
  fetch('/data')
    .then((response) => {
      if (!response.ok) {
        throw new Error('Failed to fetch JSON');
      }
      return response.json();
    })
    .then((data) => {
      let dediData = data.dediData;
      let coloData = data.coloData;
      let testiData = data.testiData;
      let ratings = data.ratings;

      ReactDOM.createRoot(document.getElementById("Dedi-Swiper")).render(
        <Swiper slidesPerView={1}
          spaceBetween={10}
          navigation={{
            prevEl: '.dedi-swiper-prev',
            nextEl: '.dedi-swiper-next'
          }}
          pagination={{ clickable: true }}
          centerInsufficientSlides={true}
          breakpoints={{
            600: {
              slidesPerView: 2,
            },
            900: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
            1800: {
              slidesPerView: 5,
            },
          }} className="swiper">
          {/* <!-- Slides --> */}
          {dediData.filter((data) => data.enabled)
            .map((dediData) =>
              <SwiperSlide>
                <div className={"card " + getCardDataClass(dediData.dataTag)} data-value={dediData.dataTag[1]}>
                  <div className="card-header text-center">
                    <h3 className="card-title">
                      <span className="font-light card-brand-name">{dediData.brandName}</span> {dediData.model}
                    </h3>
                  </div>
                  <div className="card-body">
                    <p className="card-product-description">{dediData.description}</p>
                  </div>
                  <div className="card-footer">
                    <a href={dediData.orderLink} className="btn btn-green font-light">Order Now!</a><h2 className="card-price font-light text-center" data-price={parseFloat(dediData.price).toFixed(2)}>${dediData.dataTag[0] == "1" ? parseFloat(dediData.price * (1 - (dediData.dataTag[1] / 100))).toFixed(2) : parseFloat(dediData.price).toFixed(2)}<span className="card-price-term">/mo</span></h2>
                  </div>
                </div>
              </SwiperSlide>
            )}
        </Swiper>
      )
      ReactDOM.createRoot(document.getElementById("Colo-Swiper")).render(
        <Swiper slidesPerView={1}
          spaceBetween={10}
          navigation={{
            prevEl: '.colo-swiper-prev',
            nextEl: '.colo-swiper-next'
          }}
          pagination={{ clickable: true }}
          centerInsufficientSlides={true}
          breakpoints={{
            600: {
              slidesPerView: 2,
            },
            900: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
            1800: {
              slidesPerView: 5,
            },
          }} className="swiper">
          {/* <!-- Slides --> */}
          {coloData.filter((data) => data.enabled)
            .map((coloData) =>
              <SwiperSlide>
                <div className={"card " + getCardDataClass(coloData.dataTag)} data-value={coloData.dataTag}>
                  <div className="card-header text-center">
                    <h3 className="card-title">
                      {getCardDataTitle(coloData.rackSpace)}
                    </h3>
                  </div>
                  <div className="card-body">
                    <p className="card-product-description">{coloData.description}
                    </p>
                  </div>
                  <div className="card-footer ">
                    <a href={coloData.orderLink} className="btn btn-green font-light">Order Now!</a><h2 className="card-price font-light text-center">${coloData.price}<span className="card-price-term">/mo</span></h2>
                  </div>
                </div>
              </SwiperSlide>
            )}
        </Swiper>
      )
      ReactDOM.createRoot(document.getElementById("Reviews-Testimonials")).render(
        <div className="testimonials-container">
          {testiData.map((testiData) =>
            <div className="testimonial">
              <div className="testimonial-body">
                <blockquote>{testiData.testimonial}</blockquote>
              </div>
              <br />
              <div className="testimonial-attribution">
                <span className="font-light testimonial-client-name">-{testiData.client}</span>
                <span>, {testiData.company}</span>
              </div>
            </div>
          )}
        </div>
      )
      if (testiData.length == 0 && ratings.count <= 9) {
        document.getElementById("Reviews").outerHTML = "";
      } else if (testiData.length == 0 && ratings.count > 9) {
        document.getElementById("Reviews-Title").innerText = "Ratings";
      }
      if (ratings.count > 9) {
        ReactDOM.createRoot(document.getElementById("Reviews-Ratings")).render(
          <div>
            <div className="inline-flex review-rating"><span style={{ width: (4.45 / 5.0) * 100 + "%" }}>★★★★★</span></div>
            <p className="review-rating-text">{ratings.average} of 5.0 | {ratings.count} reviews</p>
          </div>
        )
      }
      document.getElementById("Colo-Lowest-Price").innerHTML = Math.min(...coloData.map((plan) => parseFloat(plan.price)));
    })
    .catch((error) => {
      console.error('Error loading JSON:', error);
    })
}

function getCardDataClass(dataTag) {
  let key = dataTag[0];
  let value = dataTag[1];
  switch (key) {
    case 0:
    case "0":
      return "new";
      break;
    case 1:
    case "1":
      return "sale";
      break;
    case 2:
    case "2":
      return "limited"
      break;
    default:
      break;
  }
}

function getCardDataTag(dataTag) {
  let key = dataTag[0];
  let value = dataTag[1];
  if (key == 2) {
    return value;
  }
}

function getCardDataTitle(rackSpace) {
  switch (true) {
    case rackSpace == 10:
      return <div><span className="font-light card-brand-name">10U</span> Quarter Cabinet</div>
      break;
    case rackSpace == 21:
      return <div><span className="font-light card-brand-name">21U</span> Half Cabinet</div>
      break;
    case rackSpace == 31:
      return <div><span className="font-light card-brand-name">31U</span> 3 Quarter Cabinet</div>
      break;
    case rackSpace == 42:
      return <div><span className="font-light card-brand-name">42U</span> Full Cabinet</div>
    default:
      return <div><span className="font-light card-brand-name">{rackSpace + "U"}</span> Rackmount</div>
      break;
  }
}